import type { Guide } from '../types';

/**
 * S-26.10-15 — aktualizacje dla klienta z dziennika zdarzeń (scenariusz e2e 34; prace 26.10.2026, pakiet P1).
 * Rekordy: zlecenia DEMO/2026/10/AW3 (zmiana pojazdu) i AW4 (przewoźnik z TMS) z `seed-e2e.ts`.
 */
export const guide: Guide = {
  flagKey: 'clientUpdates',
  title: 'Aktualizacje dla klienta z dziennika zdarzeń',
  whatItDoes:
    'Zmiana pojazdu, przewoźnik z TMS, zmiana terminu w TMS, zaakceptowana zmiana zlecenia i anulowanie dają propozycję aktualizacji dla klienta z gotowym szkicem wiadomości. CS poprawia treść, wysyła ją ze swojej poczty i oznacza „Wysłane ręcznie” — albo pomija z powodem. Nowa propozycja tego samego rodzaju zastępuje niewysłaną. Reguła klienta na karcie kontrahenta mówi, o czym klient chce wiedzieć; bez reguły propozycje mają oznaczenie „bez reguły klienta”. Z aplikacji nic nie jest wysyłane.',
  audience: ['CS', 'planista FTL (podgląd)', 'Trade (podgląd)'],
  presentationItems: ['S-26.10-15'],
  steps: [
    {
      route: '/client-updates',
      target: 'client-updates',
      title: 'Aktualizacje do wysłania',
      description:
        'Lista propozycji: zlecenie, klient, zdarzenie, czy klient wymaga tej informacji i stan. Niewysłana po terminie przypomina o sobie.',
      action: 'Otwórz „Aktualizacje dla klienta” w menu.',
      recorder: { account: 'cs' },
    },
    {
      route: '/client-updates',
      target: 'client-update-preview-*',
      title: 'Podgląd i „Wysłane ręcznie”',
      description:
        'Szkic z adresatem z kontaktu zlecenia. Kopiujesz go albo otwierasz w swojej poczcie, wysyłasz i oznaczasz „Wysłane ręcznie” — w historii zlecenia zostaje kto i kiedy, bez adresu.',
      action: 'Kliknij „Podgląd i wyślij”, popraw treść i oznacz „Wysłane ręcznie”.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-update-preview-*' }] },
    },
    {
      route: '/client-updates',
      target: 'client-update-skip-*',
      title: 'Pomiń z powodem',
      description: 'Gdy klient tej informacji nie potrzebuje, pomijasz propozycję z powodem — zostaje w historii zlecenia.',
      action: 'Kliknij „Pomiń z powodem”, wpisz powód i kliknij „Pomiń”.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-update-skip-*' }] },
    },
    {
      route: '/contractors/:contractorId/show',
      record: { description: 'dowolny kontrahent z kartoteki', listPath: '/contractors' },
      target: 'client-rule-update',
      title: 'Reguła aktualizacji klienta',
      description:
        'O czym klient chce wiedzieć: zmiana pojazdu, przewoźnik, termin, zaakceptowana zmiana, anulowanie — z właścicielem, datą obowiązywania i historią.',
      action: 'Na karcie kontrahenta kliknij „Wpisz regułę” w sekcji „Reguła aktualizacji dla klienta (CS)”.',
      recorder: { account: 'cs', demo: { kind: 'contractorOfOrder', number: 'DEMO/2026/10/AW3' } },
    },
  ],
};
